<template>
  <div :class="$style.container">
    <label
      v-if="label"
      :class="[
        $style.label,
        $style['label-color'],
        $style['label-font'],
        $style['label-position'],
        $style['label-typography'],
      ]"
    >
      {{ label }}
    </label>
    <SearchBarLegacy
      :class="{[$style.error]: hasError}"
      :placeholderText="placeholderText"
      :searchText="searchText"
      :selectedValues="value"
      @blur="handleSearchBarBlur"
      @filterDelete="handleFilterDelete"
      @focus="handleSearchBarFocus"
      @input="handleSearchBarInput"
    />
    <MultiselectDropdownLegacy
      :canSelectAll="isSelectAllAllowed"
      :class="$style.multiselect"
      :loading="loadingOptions"
      :open="open"
      :options="options"
      :totalOptions="totalOptions"
      :value="value"
      @close="handleClose"
      @input="handleMultiSelectInput"
    />
    <slot name="errorMessage" />
  </div>
</template>

<script>
import MultiselectDropdownLegacy from 'client/components/SearchWithMultiSelect/MultiselectDropdownLegacy.vue';
import SearchBarLegacy from 'client/components/SearchWithMultiSelect/SearchBarLegacy.vue';

/**
 * @event {{value: Any, name: String}[]} input - value has changed
 * @event {string} filter - filter text has changed
 */
export default {
  name: 'SearchWithMultiSelectLegacy',

  components: {
    SearchBarLegacy,
    MultiselectDropdownLegacy,
  },

  inject: ['$validator'],

  props: {
    canSelectAll: Boolean,
    /**
     * Displays Error Styling
     */
    hasError: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    loadingOptions: {
      type: Boolean,
      default: false,
    },
    /**
     * @type {{value: Any, name: String}[]}
     */
    options: {
      type: Array,
      default: () => [],
    },
    placeholderText: {
      type: String,
      default: 'Search',
    },
    searchText: {
      type: String,
      default: '',
    },
    totalOptions: {
      type: Number,
      default: undefined,
    },
    /**
     * @type {{value: Any, name: String}[]}
     */
    value: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    open: false,
    searchFocus: false,
    multiselectFocus: false,
  }),

  computed: {
    isSelectAllAllowed() {
      // don't allow select all on a filtered list
      return !this.searchBarText && this.canSelectAll;
    },

    searchBarText() {
      if (this.open) {
        return this.searchText;
      }
      return '';
    },
  },

  methods: {
    handleClose() {
      // Leave the selector open when the search is focused
      if (!this.searchFocus) {
        this.open = false;
      }
    },
    handleFilterDelete(item) {
      const newValue = this.value.filter(val => val.value !== item.value);
      this.$emit('input', newValue);
    },
    handleMultiSelectInput(value) {
      this.$emit('input', value);
    },
    handleSearchBarBlur() {
      this.searchFocus = false;
    },

    handleSearchBarFocus() {
      if (!this.searchFocus && !this.open) {
        this.$emit('filter', '');
      }
      this.searchFocus = true;
      this.open = true;
    },

    handleSearchBarInput(value) {
      this.$emit('filter', value);
    },
  },
};
</script>

<style module>
@import "../FormValidation/css/formFields.css";

.container .error {
  border-color: var(--jc-color-error-base);
}

.multiselect {
  width: 100%;
}
</style>
